import lozad from 'lozad';
import AOS from 'aos';
import navMenu from "./components/nav-menu";
import initAccordion from "./components/accordion";
import {initTestimonialsSwiper, initVideoSwiper } from "./components/swiper";
import hideHeaderScrollDown from "./components/header";

//init lozad
const observer = lozad('.lozad', {
    rootMargin: '100px 0px', // syntax similar to that of CSS Margin
    enableAutoReload: true // it will reload the new image when validating attributes changes
});

observer.observe();

// AOS init
AOS.init({
    once: true, // whether animation should happen only once - while scrolling down
    duration: 550, // values from 0 to 3000, with step 50ms
    disable: 'phone', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    delay: 300, // values from 0 to 3000, with step 50ms
});

function pauseVideos(pausedHero = false) {
    const playVideo = document.querySelectorAll('.js-play-video'),
        playVideoHero = document.querySelector('.js-play-hero-video');

    if(playVideo.length) {
        [...playVideo].forEach((item) => {
            let video = item.previousElementSibling;

            if(video) {
                if(!video.paused) {
                    video.pause();
                    video.nextElementSibling.classList.remove('hide');
                }
            }
        });
    }

    if(playVideoHero && pausedHero) {
        let video = document.querySelector('.hero__video');

        if(video) {
            if(!video.paused) {
                video.pause();
                playVideoHero.classList.remove('hide');
            }
        }
    }
}

function playVideoHero() {
    const video = document.getElementById('st-hero-video'),
        btn = document.querySelector('.js-play-hero-video'),
        text = document.querySelector('.js-hero-btn-text');
    if(!video || !text) return;
    pauseVideos();

    dl.log(video.paused);

    if(video.paused) {
        video.play();
        text.textContent = 'Pause Video';
        setTimeout(() => {
            btn.classList.add('hide');
        }, 2000);
    } else {
        video.pause();
        text.textContent = 'Play Video';
        btn.classList.remove('hide');
    }
}

function hidePlayBtnFromSlider() {
    let activeSlide = document.querySelectorAll('.swiper-slide-active');

    if(activeSlide.length) {
        [...activeSlide].forEach((item) => {
            let video = item.querySelector('.s-video__video'),
                playBtn = item.querySelector('.btn-play-wrap');

            if(video && video && playBtn) {
                if(!video.paused) {
                    playBtn.classList.add('hide');
                }
            }
        });
    }
}

function hidePlayBtnAudio() {
    let audioEl = document.querySelectorAll('.js-audio');

    if(audioEl.length) {
        [...audioEl].forEach((item) => {
            let audio = item,
                playBtn = item.previousElementSibling;

            if(audio && playBtn) {
                if(!audio.paused) {
                    playBtn.classList.add('hide');
                }
            }
        });
    }
}

window.addEventListener("DOMContentLoaded", () => {
    navMenu();
    initTestimonialsSwiper();
    initVideoSwiper();
    hideHeaderScrollDown();
    initAccordion();

    //play video hero
    const heroPlayBtn = document.querySelector('.js-play-hero-video'),
        heroSection = document.querySelector('.hero');
    let timerVideoHero;

    if(heroPlayBtn) {
        heroPlayBtn.addEventListener('click', function() {
            playVideoHero();
        });
    }

    if(heroSection) {
        heroSection.addEventListener('mousemove', function H(e) {
            let playBtn = this.querySelector('.btn-play'),
                video = heroSection.querySelector('.hero__video');

            if(playBtn) {
                playBtn.classList.remove('hide');
                clearTimeout(timerVideoHero);
                timerVideoHero = setTimeout(() => {
                    if(video) {
                        if(!video.paused) {
                            playBtn.classList.add('hide');
                        }
                    }
                }, 3000);
            }
        });
    }

    //play video section
    const playVideo = document.querySelectorAll('.js-play-video');

    if(playVideo.length) {
        [...playVideo].forEach((item) => {
            item.addEventListener('click', function H(e) {
                let target = e.target,
                    video = target.closest('.btn-play-wrap').previousElementSibling,
                    audio = target.closest('.btn-play-wrap').nextElementSibling,
                    text = this.querySelector('.btn-play-text');

                if(!text.classList.contains('audio')) {
                    if(video.paused) {
                        pauseVideos(true);
                        video.play();
                        text.textContent = 'Pause Video';
                        setTimeout(() => {
                            this.classList.add('hide');
                        }, 2000);
                    } else {
                        video.pause();
                        text.textContent = 'Play Video';
                        this.classList.remove('hide');
                    }
                }

                if(audio) {
                    if(audio.paused) {
                        audio.play();
                        text.textContent = 'Pause Audio';
                        setTimeout(() => {
                            this.classList.add('hide');
                        }, 2000);
                    } else {
                        audio.pause();
                        text.textContent = 'Play Audio';
                    }
                }
            });
        });
    }

    const slide = document.querySelectorAll('.swiper-slide');
    let timerVideo;

    if(slide.length) {
        [...slide].forEach((item) => {
            item.addEventListener('mousemove', function H(e) {
                let playBtn = this.querySelector('.btn-play-wrap');
                if(playBtn) {
                    playBtn.classList.remove('hide');
                    clearTimeout(timerVideo);
                    timerVideo = setTimeout(() => {
                        hidePlayBtnFromSlider();
                    }, 3000);
                }
            });
        });
    }

    const audio = document.querySelectorAll('.js-audio');
    let timerAudio;

    if(audio.length) {
        [...audio].forEach((item) => {
            let videoWrap = item.closest('.s-video__video-wrap');
            if(videoWrap) {
                videoWrap.addEventListener('mousemove', function H(e) {
                    let playBtn = videoWrap.querySelector('.btn-play-wrap');
                    if(playBtn) {
                        playBtn.classList.remove('hide');
                        clearTimeout(timerAudio);
                        timerAudio = setTimeout(() => {
                            hidePlayBtnAudio();
                        }, 3000);
                    }
                });
            }
        });
    }

    //Two column video
    const twoColumnVideo = document.querySelectorAll('.two-columns__video-wrap');
    let timerVideoTwoColumns;

    if(twoColumnVideo.length) {
        [...twoColumnVideo].forEach((item) => {
            item.addEventListener('mousemove', function H(e) {
                let playBtn = this.querySelector('.btn-play-wrap');
                if(playBtn) {
                    playBtn.classList.remove('hide');
                    clearTimeout(timerVideoTwoColumns);
                    timerVideoTwoColumns = setTimeout(() => {
                        let video = item.querySelector('.two-columns__video'),
                            playBtn = item.querySelector('.btn-play-wrap');

                        if(video && video && playBtn) {
                            if(!video.paused) {
                                playBtn.classList.add('hide');
                            }
                        }
                    }, 3000);
                }
            });
        });
    }
});

//smooth scrolling
$('a').on('click', function H(e) {
    let el = $(this),
        dest = el.attr('href');
    let destId = dest.slice(dest.indexOf('#'));

    if(destId !== undefined && destId !== '' && destId !== '/' && $(destId).offset() !== undefined ) {
        $('html').animate(
            { scrollTop: $(destId).offset().top }, 800 // speed
        );
    }
});
